var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30642 1.29415C2.38776 1.26494 2.47353 1.25 2.55995 1.25H13.44C13.5265 1.25 13.6122 1.26494 13.6936 1.29415C13.924 1.3769 14.1312 1.512 14.3001 1.68771C14.469 1.86334 14.5951 2.07493 14.6702 2.30567C14.7453 2.53636 14.7677 2.78108 14.7361 3.02142C14.7044 3.26178 14.6193 3.4926 14.4863 3.69611C14.4662 3.72687 14.4438 3.75611 14.4194 3.7836L10.4239 8.28485V14C10.4239 14.2856 10.2616 14.5465 10.0054 14.6727C9.7492 14.799 9.44352 14.7688 9.217 14.5948L5.86927 12.0234C5.68446 11.8814 5.57614 11.6616 5.57614 11.4286V8.28485L1.58058 3.7836C1.55619 3.75611 1.53384 3.72687 1.51373 3.69611C1.38068 3.4926 1.29561 3.26178 1.26394 3.02142C1.23228 2.78108 1.25469 2.53637 1.32977 2.30567C1.40487 2.07493 1.53102 1.86334 1.69987 1.68771C1.86878 1.512 2.07603 1.3769 2.30642 1.29415ZM2.76468 2.75C2.76135 2.75609 2.75846 2.76274 2.75612 2.76991C2.75043 2.78742 2.74859 2.80655 2.75109 2.82549C2.75216 2.83362 2.75398 2.84139 2.75644 2.84872L6.88704 7.50211C7.00886 7.63935 7.07614 7.81649 7.07614 8V11.0589L8.92386 12.4782V8C8.92386 7.81649 8.99114 7.63935 9.11296 7.50211L13.2436 2.84872C13.246 2.84139 13.2478 2.83362 13.2489 2.82549C13.2514 2.80655 13.2496 2.78742 13.2439 2.76991C13.2415 2.76274 13.2386 2.75609 13.2353 2.75H2.76468Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c6dbe61def789cc8fe29030f48b08cd4.svg";
export { ForwardRef as ReactComponent };